// www.figma.com/file/3PxdzWWVKzf7JdpUqyCqQH/Ownable-Site-Layout?node-id=1128%3A1267&t=L1OMHD0yFBCCGbOs-0

import { SUPPRESS_PRODUCT_DISPLAY_ZOOM_LIMIT } from '@Components/BigBrowse/BigBrowseConfig';
import type {
  CameraProps,
  PlaneSize,
  Position2D,
} from '@Components/BigBrowse/Model/ModelTypes';
import { getRectanglePositionInsideRectangle } from '@Utils/3d';

const FIGMA_PRODUCT_SIDE = 163;
const FIGMA_HERO_SIZE = 376;
const FIGMA_DISPLAY_HORIZONTAL_MARGIN = 45;
const FIGMA_DISPLAY_VERTICAL_MARGIN = 35;
const FIGMA_DISPLAY_HORIZONTAL_MARGIN_COLLAPSED_VIEW =
  FIGMA_DISPLAY_HORIZONTAL_MARGIN * 1.2;
const FIGMA_DISPLAY_VERTICAL_MARGIN_COLLAPSED_VIEW =
  FIGMA_DISPLAY_VERTICAL_MARGIN * 1.2;
const FIGMA_DISPLAY_SIZE: PlaneSize = { width: 594, height: 877 };

// export const shouldCollapseDisplayToHeroOnly = (zoom: number): boolean =>
//   zoom <= SUPPRESS_PRODUCT_DISPLAY_ZOOM_LIMIT;

const FIGMA_PRODUCT_POSITIONS: { left: number; top: number }[] = [
  { left: 0, top: 0 },
  { left: 216, top: 35 },
  { left: 431, top: 0 },
  { left: 431, top: 237 },
  { left: 431, top: 476 },
  { left: 431, top: 714 },
  { left: 214, top: 749 },
  { left: 0, top: 714 },
];

const FIGMA_HERO_POSITION: { left: number; top: number } = {
  left: 0,
  top: 268,
};

const FIGMA_HORIZONTAL_FLOOR_PATHWAY_WIDTH = 163;
const FIGMA_VERTICAL_FLOOR_PATHWAY_WIDTH = 163;

export const getProductCardSize = (): number => FIGMA_PRODUCT_SIDE;
export const getHeroCardSize = (collapsedView?: boolean): number =>
  collapsedView ? FIGMA_HERO_SIZE : FIGMA_HERO_SIZE;

const getDisplayHorizontalMargin = (collapsedView?: boolean): number =>
  collapsedView
    ? FIGMA_DISPLAY_HORIZONTAL_MARGIN_COLLAPSED_VIEW
    : FIGMA_DISPLAY_HORIZONTAL_MARGIN;
const getDisplayVerticalMargin = (collapsedView?: boolean): number =>
  collapsedView
    ? FIGMA_DISPLAY_VERTICAL_MARGIN_COLLAPSED_VIEW
    : FIGMA_DISPLAY_VERTICAL_MARGIN;

const getDisplaySize = (collapsedView?: boolean): PlaneSize =>
  collapsedView
    ? { width: FIGMA_HERO_SIZE, height: FIGMA_HERO_SIZE }
    : { ...FIGMA_DISPLAY_SIZE };

const calculateProductPosition = (collapsedView?: boolean) =>
  getRectanglePositionInsideRectangle({
    ...getDisplaySize(collapsedView),
  })({
    width: getProductCardSize(),
    height: getProductCardSize(),
  });

export const getProductPositionByIndex =
  (collapsedView?: boolean) => (index: number) =>
    calculateProductPosition(collapsedView)(FIGMA_PRODUCT_POSITIONS[index]);

const calculateHeroPosition = (collapsedView: boolean) =>
  getRectanglePositionInsideRectangle({
    ...getDisplaySize(collapsedView),
  })({
    width: getHeroCardSize(collapsedView),
    height: getHeroCardSize(collapsedView),
  });

export const getHeroPosition = (collapsedView: boolean): Position2D =>
  calculateHeroPosition(collapsedView)(FIGMA_HERO_POSITION);

export const getFloorPathwaySize = () => ({
  horizontal: FIGMA_HORIZONTAL_FLOOR_PATHWAY_WIDTH,
  vertical: FIGMA_VERTICAL_FLOOR_PATHWAY_WIDTH,
});

// TODO: This whole thing needs memoization
export const getDisplaySizeWithMargins = (
  collapsedView: boolean
): PlaneSize => ({
  width:
    getDisplaySize(collapsedView).width +
    getDisplayHorizontalMargin(collapsedView) * 2,
  height:
    getDisplaySize(collapsedView).height +
    getDisplayVerticalMargin(collapsedView) * 2,
});
